"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _order = require("@/api/order");

var _logistics = require("@/api/logistics");

var _validate = require("@/utils/validate");

var _dialog = require("@/libs/dialog");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = {
  name: "GoodsDeliver",
  components: {},
  props: {},
  data: function data() {
    return {
      types: [{
        type: "1",
        title: "发货"
      }, {
        type: "2",
        title: "送货"
      }, {
        type: "3",
        title: "无需发货"
      }],
      active: 0,
      orderId: "",
      delivery: {},
      express: [],
      type: "1",
      deliveryName: "",
      expressCode: "",
      expressNumber: '',
      deliveryTel: ""
    };
  },
  watch: {
    "$route.params.oid": function $routeParamsOid(newVal) {
      var that = this;

      if (newVal != undefined) {
        that.orderId = newVal;
        that.getIndex();
      }
    }
  },
  created: function created() {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/assets/js/media_750'));
    });
  },
  mounted: function mounted() {
    this.orderId = this.$route.params.oid;
    this.getIndex();
    this.getLogistics();
  },
  methods: {
    changeType: function changeType(item, index) {
      this.active = index;
      this.type = item.type;
      this.deliveryName = "";
      this.deliveryTel = "";
      this.expressCode = "";
      this.expressNumber = "";
    },
    getIndex: function getIndex() {
      var _this = this;

      (0, _order.orderDetailApi)({
        orderNo: this.orderId
      }).then(function (res) {
        _this.delivery = res;
      }).catch(function (error) {
        _this.$dialog.error(error.message);
      });
    },
    getLogistics: function getLogistics() {
      var _this2 = this;

      (0, _logistics.expressList)({
        page: 1,
        limit: 999,
        isShow: 1
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2.express = res.list;

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    saveInfo: function () {
      var _saveInfo = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2() {
        var that, deliveryName, deliveryTel, save;
        return _index.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // type: '1',
                //   expressRecordType: '1',
                //   expressId: '',
                //   expressCode: '',
                //   deliveryName: '',
                //   deliveryTel: '',
                //   // expressName: '',
                //   expressNumber: '',
                //   expressTempId: '',
                //   toAddr: '',
                //   toName: '',
                //   toTel: '',
                //   orderNo: ''
                that = this, deliveryName = that.deliveryName, deliveryTel = that.deliveryTel, save = {};
                save.type = that.type;
                save.orderNo = that.orderId;
                _context2.t0 = that.type;
                _context2.next = _context2.t0 === "1" ? 6 : _context2.t0 === "2" ? 15 : _context2.t0 === "3" ? 27 : 29;
                break;

              case 6:
                if (that.expressCode) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", that.$dialog.error('请输入快递公司'));

              case 8:
                if (that.expressNumber) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", that.$dialog.error('请输入快递单号'));

              case 10:
                save.expressNumber = that.expressNumber;
                save.expressRecordType = 1;
                save.expressCode = that.expressCode;
                that.setInfo(save);
                return _context2.abrupt("break", 29);

              case 15:
                _context2.prev = 15;
                _context2.next = 18;
                return this.$validator({
                  deliveryName: [(0, _validate.required)(_validate.required.message("发货人姓名"))],
                  deliveryTel: [(0, _validate.required)(_validate.required.message("发货人电话"))]
                }).validate({
                  deliveryName: deliveryName,
                  deliveryTel: deliveryTel
                });

              case 18:
                _context2.next = 23;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t1 = _context2["catch"](15);
                return _context2.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context2.t1));

              case 23:
                save.deliveryName = deliveryName;
                save.deliveryTel = deliveryTel;
                that.setInfo(save);
                return _context2.abrupt("break", 29);

              case 27:
                that.setInfo(save);
                return _context2.abrupt("break", 29);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[15, 20]]);
      }));

      function saveInfo() {
        return _saveInfo.apply(this, arguments);
      }

      return saveInfo;
    }(),
    setInfo: function setInfo(item) {
      var that = this;
      (0, _order.orderSendApi)(item).then(function (res) {
        that.$dialog.success('发送货成功');
        that.$router.go(-1);
      }, function (error) {
        that.$dialog.error(error.message);
      });
    }
  }
};
exports.default = _default;